import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconArrowLeftOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M12.626 6.96a1 1 0 1 1 1.414 1.414L7.414 15H27a1 1 0 0 1 0 2H7.414l6.626 6.626a1 1 0 1 1-1.414 1.414l-8.333-8.333a1 1 0 0 1 0-1.414z" /></svg>;
export default SvgIconArrowLeftOutlined;